module.exports = __webpack_public_path__ + "img/favicon.c581f5e4.svg";